export default __webpack_public_path__ + "static/media/ibx-logo.3333e260.png";